$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Placeholder scripts
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search Website')
  $('#mobileSearchInput').val('')

  // NavBar border-radius script
  $('.groups .group').each(function () {

    $(this).find('.items > .item').each(function () {
      $(this).addClass('radius-class');

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`radius-class`);
      });
    });

    $(this).find('.navClonedItem').removeClass('radius-class')
  });

  // TOGGLE
  $('.mobile-nav-toggle').append(`
    <div></div>
    <div></div>
    <div></div>
    `)

  // Tickets & Deals
  $('.ticket').text("Buy Tickets")
  $('.mobile-menu-ticket-btn').text("Buy Tickets")

  // Mobile cloned icons
  $('.standAloneDirections').clone().appendTo('.mobile-menu-subheader')
  $('.mobile-menu-subheader .standAloneDirections').text('')
  $('.sponsor-header').clone().appendTo('.mobile-menu-subheader')

  // Countdown

  $('.default-infosite-banner').insertAfter('.header')
  setTimeout(() => {

    $('#siteInfoBannerWidget').clone().appendTo('.mobile-banner')
  }, 2000)


  // Footer signup script
  $('.footer .signup-container .emailSignupText').text('Sign Up For Mower County Fair’s Exciting Deals & Updates')
  $('.footer .signup-container .emailInputSubmit a').text('subscribe')

  $('.footer .emailInputField input').attr('placeholder', 'EMAIL ADDRESS:')
  $('.footer .emailInputField input').val('')


});

$(window).load(function () {
  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});

